import "../../../../public/project/documents/Documents.css";

import { FileBlueIcon } from "../../../../../assets";
import { DocumentsTab } from "../../../../shared/projects/project/documents";
import { useDocuments } from "./useDocuments";

const Documents = (): JSX.Element => {
  const { documents, isLoading, isFullAccessProject, downloadDocument } = useDocuments();

  if (!isFullAccessProject) {
    return (
      <div className="AssetManagerProjectDocuments">
        <h2>Documents</h2>
        {!isLoading && (
          <div className="AssetManagerProjectDocumentsList">
            {documents && documents.length ? (
              documents.map((documentItem) => (
                <button
                  className="AssetManagerProjectDocumentItem"
                  key={documentItem.uuid}
                  onClick={() => downloadDocument(documentItem.versionUuid)}
                  type="button"
                >
                  <div className="AssetManagerProjectDocumentItemInfo">
                    <FileBlueIcon />
                    <div className="AssetManagerProjectDocumentTextGroup">
                      <p className="AssetManagerProjectDocumentTitle body1">{documentItem.type}</p>
                      {documentItem.customVariant || documentItem.variant ? (
                        <p className="AssetManagerProjectDocumentVariant body1">
                          {documentItem.customVariant || documentItem.variant}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <p className="AssetManagerProjectDocumentUploadedDate body2">
                    {`Uploaded on ${documentItem.createdAt.toLocaleDateString("en-GB")}`}
                  </p>
                </button>
              ))
            ) : (
              <p className="AssetManagerProjectDocumentsEmptyState body2">
                This project doesn&apos;t have any documents yet.
              </p>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <DocumentsTab descriptionText="Manage project files, upload new versions, and review document history from this workspace." />
  );
};

export default Documents;
